/**
 * Event winners sheets as PNGs under `public/Bulandi Event/winners/`.
 * Keys are `bulandiSubEvents` `id` values.
 */

const ROOT = "/Bulandi Event/winners";

/** @type {Record<string, string | string[]>} */
const EVENT_ID_TO_RELATIVE_PNG = {
  "brain-burn-intermediates": "brain_burn.png",
  "mind-maze-seniors": "mind_maze.png",
};

function encodePublicPath(relativePath) {
  const segments = `${ROOT}/${relativePath}`.split("/").filter(Boolean);
  return `/${segments.map((s) => encodeURIComponent(s)).join("/")}`;
}

/**
 * @param {{ id?: string, name?: string } | null | undefined} event
 * @returns {string[] | null}
 */
export function getBulandiEventWinnersPngUrls(event) {
  if (!event?.id) return null;
  const rel = EVENT_ID_TO_RELATIVE_PNG[event.id];
  if (!rel) return null;
  const paths = Array.isArray(rel) ? rel : [rel];
  return paths.map(encodePublicPath);
}

/**
 * @param {{ id?: string, name?: string } | null | undefined} event
 * @returns {boolean}
 */
export function hasBulandiEventWinnersPng(event) {
  return Boolean(getBulandiEventWinnersPngUrls(event)?.length);
}

/**
 * @param {{ name?: string } | null | undefined} event
 * @param {number} [pageIndex=0]
 */
export function getBulandiEventWinnersPngDownloadFilename(event, pageIndex = 0) {
  const raw = String(event?.name || "event")
    .trim()
    .replace(/[<>:"/\\|?*]+/g, "")
    .replace(/\s+/g, "-");
  const base = raw.length ? raw : "event";
  const urls = getBulandiEventWinnersPngUrls(event);
  const suffix = urls && urls.length > 1 ? `-page-${pageIndex + 1}` : "";
  return `Bulandi-2026-${base}-winners${suffix}.png`;
}
